"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7574],{

/***/ 4680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "t": function() { return /* binding */ thoundsandDelimiter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72227);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(number) {
  if (!number) {
    return "0";
  }
  return number.toLocaleString("de-DE", { maximumFractionDigits: 2 }).toString();
}
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const StyledCurrency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  width: max-content;
  display: inline-block;
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => p.weight ? FONT_WEIGHT_MAP[p.weight] : "inherit"};
`;
const Text = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span(({ underline }) => _emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv`
    text-decoration: ${underline ? "underline" : ""};
  `);
const Currency = (_a) => {
  var _b = _a, {
    value,
    hideCurrency = false,
    space = false,
    underline = false
  } = _b, props = __objRest(_b, [
    "value",
    "hideCurrency",
    "space",
    "underline"
  ]);
  if (!value && value !== 0) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), thoundsandDelimiter(value), !hideCurrency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, space && " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, {
    underline
  }, "\u0111")));
};




/***/ }),

/***/ 36344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25989);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledFlex = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .Z.div((_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
    {
      display: "flex",
      flexDirection: props.direction,
      gap: theme.spacing[props.gap],
      columnGap: theme.spacing[props.gapX],
      rowGap: theme.spacing[props.gapY],
      justifyContent: buildVariant(props.justify),
      alignItems: buildVariant(props.align)
    }
  ];
});
const buildVariant = (variant) => {
  switch (variant) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return variant;
  }
};
StyledFlex.defaultProps = {
  direction: "row",
  gap: "s0",
  gapX: "s0",
  gapY: "s0",
  justify: "start",
  align: "baseline"
};
const Flex = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(StyledFlex, __spreadValues({}, props));




/***/ }),

/***/ 57926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CashColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const CashColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.435 5C2.195 5 2 5.195 2 5.436V17.609C2 17.849 2.195 18.044 2.435 18.044H21.565C21.806 18.044 22 17.849 22 17.609V5.436C22 5.195 21.806 5 21.565 5H2.435Z",
          fill: "#1CC54F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.9142 6.30505C5.9142 7.74505 4.7452 8.91305 3.3042 8.91305V14.1301C4.7452 14.1301 5.9142 15.2991 5.9142 16.7401H18.0882C18.0882 15.2991 19.2552 14.1301 20.6962 14.1301V8.91305C19.2552 8.91305 18.0882 7.74505 18.0882 6.30505H5.9142Z",
          fill: "#B9F5B4"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.95703 11.522C8.95703 13.203 10.319 14.566 12 14.566C13.681 14.566 15.044 13.203 15.044 11.522C15.044 9.841 13.681 8.479 12 8.479C10.319 8.479 8.95703 9.841 8.95703 11.522Z",
          fill: "#1CC54F"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 39781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ShareFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const ShareFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z",
          stroke: "#82869E",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 66349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63103);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69168);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title), link && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .RightOutlined */ .g, {
    color: link.color
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);




/***/ }),

/***/ 51470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SellerLine; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88123);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16277);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4680);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68481);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => `
  display: flex;
  padding: 12px;
  align-items: center;
  background: white;
  border-bottom: ${props.border ? "1px" : "0px"} solid #e0e0e0;
`);
const Description = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;
const FlexAuto = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b)`
  flex: 0 0 auto;
`;
const SellerLine = (_a) => {
  var _b = _a, {
    seller,
    total,
    selectedCount,
    totalCount,
    border = true,
    isLogoHidden = false,
    alterName
  } = _b, props = __objRest(_b, [
    "seller",
    "total",
    "selectedCount",
    "totalCount",
    "border",
    "isLogoHidden",
    "alterName"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    border
  }), isLogoHidden ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FlexAuto, {
    marginRight: "s12"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    contain: true,
    src: seller == null ? void 0 : seller.logo,
    border: true,
    width: 38,
    height: 38,
    borderRadius: 19
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Description, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    weight: "medium"
  }, alterName ? alterName : seller == null ? void 0 : seller.displayName), totalCount && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .YS, {
    level: 1,
    color: "textSecondary"
  }, selectedCount, "/", totalCount, " ", (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("s\u1EA3n ph\u1EA9m"))), total && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FlexAuto, {
    style: { fontWeight: 500 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Currency */ .F, {
    value: total,
    color: "#eb1f3a"
  })));
};




/***/ }),

/***/ 23517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ EmptyState; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(36344);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js + 1 modules
var LazyImage_es = __webpack_require__(16277);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(71323);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/EmptyState/search-no-result.es.js
var img = "data:image/png;base64,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";
  var emptyImage = img;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(68481);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/EmptyState/EmptyState.es.js





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EmptyState = (_a) => {
  var _b = _a, {
    text
  } = _b, props = __objRest(_b, [
    "text"
  ]);
  return /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, __spreadProps(__spreadValues({}, props), {
    direction: "column",
    justify: "center",
    align: "center"
  }), /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
    height: 128,
    width: 128,
    src: emptyImage
  }), /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    color: "#848788",
    marginTop: "s24",
    paddingLeft: "s32",
    weight: "regular"
  }, text || (0,i18n_es.t)("Kh\xF4ng t\xECm th\u1EA5y d\u1EEF li\u1EC7u")));
};




/***/ }),

/***/ 46598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ GroupBuyShareButton; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24122);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39781);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17042);






const GroupBuyShareButton = ({
  title,
  text,
  url
}) => {
  const isShareAvailable = (0,_helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__/* .isBrowserShareAvailable */ .IS)() || (0,_helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__/* .isTerraShareAvailable */ .VV)();
  const onShare = () => {
    (0,_helpers_browser_share_es_js__WEBPACK_IMPORTED_MODULE_1__/* .share */ .BN)(title, text, url);
  };
  return isShareAvailable && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
    onClick: onShare,
    prefix: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .ShareFilled */ .r, {
      size: 20,
      color: "#fff"
    }),
    paddingLeft: "s16"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("K\xEAu g\u1ECDi mua chung"));
};




/***/ }),

/***/ 68328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ PromotionItem; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43328);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57926);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17016);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71323);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68481);





const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ hasBorder }) => `
  display: flex;
  margin-top: 7px;
  align-items: center;
  ${hasBorder ? " border-bottom: 1px dashed #e0e0e0; padding-bottom: 16px;" : ""}
`);
const Name = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  flex: 1;
  align-item: center;
  margin-left: 2px;
`;
const Quantity = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  color: #848788;
`;
const Applied = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  font-size: 0.625rem;
  line-height: 1rem;
  color: #848788;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  text-transform: uppercase;
  padding: 3px;
  padding-bottom: 1px;
  margin-right: 5px;
`;
const PromotionItem = ({
  item = { quantity: 1, name: "", sku: "" },
  type,
  name,
  hasBorder,
  className
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    className,
    hasBorder
  }, type === "product" || type === "voucher" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .GiftColored */ .x, null) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CashColored */ .B, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Name, {
    lineHeight: 20
  }, type === "product" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Quantity, null, item.quantity, "x ") : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Applied, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("\u0110\xE3 \xE1p d\u1EE5ng")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, name || item.name)));
};




/***/ }),

/***/ 17042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ share; },
/* harmony export */   "IS": function() { return /* binding */ isBrowserShareAvailable; },
/* harmony export */   "VV": function() { return /* binding */ isTerraShareAvailable; }
/* harmony export */ });
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47360);


const isBrowserShareAvailable = () => {
  return typeof navigator !== "undefined" && !!navigator.share;
};
const isTerraShareAvailable = () => _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable();
let isSharing = false;
const share = async (title, text, url) => {
  const isTerraShare = isTerraShareAvailable();
  const isBrowserShare = isBrowserShareAvailable();
  try {
    if (!isTerraShare && !isBrowserShare || isSharing) {
      return;
    }
    isSharing = true;
    if (isTerraShare) {
      await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].share */ .Z.share({ title, text, url });
    } else {
      await navigator.share({ title, text, url });
    }
  } catch (e) {
  } finally {
    isSharing = false;
  }
};




/***/ })

}]);